import { all } from 'redux-saga/effects';
import Auth from './Auth';
import UserProfile from './UserProfile';

export default function* rootSaga(getState) {
  yield all([
    Auth(),
    UserProfile()
  ]);
}
